import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {computed} from "vue";
import ClientInfoDataProviderCard
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/ClientInfoDataProviderCard.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";



const __default__ = {
    name: "ClientDataProviderInfo"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {}
  },
  setup(__props: any) {

let props = __props;

let authListByPlatforms = computed(() => {
    let result: {
        platform: OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel,
        integrations: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel[]
    }[] = [];
    let platforms = OperatorAccountStore.integrationPlatformDictionary.value;
    for (let platformId in platforms) {
        if (platforms.hasOwnProperty(platformId)) {
            let platform = platforms[platformId];
            if (platform.isDataProvider) {
                let integrations = props.site.integrations.filter(integration => {
                    return integration.platformId == platform.id && integration.dataProviderPlatformData?.entityTypes.length > 0;
                });
                if (integrations.length) {
                    result.push({
                        platform,
                        integrations
                    });
                }
            }
        }
    }
    return result;
});

return (_ctx: any,_cache: any) => {
  return (_unref(authListByPlatforms).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authListByPlatforms), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrations, (integration) => {
              return (_openBlock(), _createBlock(ClientInfoDataProviderCard, {
                key: integration.authPrimaryId,
                userdata: __props.userdata,
                platform: item.platform,
                integration: integration,
                "show-auth-title": item.integrations.length > 1
              }, null, 8, ["userdata", "platform", "integration", "show-auth-title"]))
            }), 128))
          ], 64))
        }), 256))
      ]))
    : _createCommentVNode("", true)
}
}

})